import App from "../../App";
import Button from "./Button";
import SwitchButton from "./SwitchButton"; 

class Cursor {
    private customPointerOptionEnabled: boolean = null;
    private cursorStyles = null;
    private normalIcon = "url('assets/textures/cursor/cursor.png'),auto";
    private hoverIcon = "url('assets/textures/cursor/cursor_hover.png'),auto";
    private _isCustom: boolean = true;
    private elementsAffected: Button[] = [];

    public init(cursorStyles: any, customPointerOptionEnabled: boolean) {
        this.customPointerOptionEnabled = customPointerOptionEnabled; 
        this.cursorStyles = cursorStyles;
        this.isCustom = this._isCustom;
    }
    public addAffectedElement(element: Button) {
            element.cursor = "hover";
            // this.elementsAffected = this.elementsAffected.filter(el => el.constructor.name !== "SwitchButton")
            this.elementsAffected.push(element);
        // console.log('lemmy elsss : ', this.elementsAffected); //! lemmy check this array! Every time a sound menu is opened a new set of SwitchButtons are created and added into! Fuck!
    }

    public set isCustom(enabled: boolean) {
        this._isCustom = enabled;
        if (!enabled) {
            this.cursorStyles.default = "inherit";
            this.cursorStyles.hover = "inherit";
            this.elementsAffected.forEach(button => button.cursor = "inherit");
        } else {
            this.cursorStyles.default = this.normalIcon;
            this.cursorStyles.hover = this.hoverIcon;
            this.elementsAffected.forEach(button => button.cursor = "hover");
        }
    }

    public get isCustom(): boolean {
        return this._isCustom;
    }

    private cursorShining() {
        //TODO lemmy add cursor shining
        // const shiningUrl = "url('assets/textures/cursor/shining.png')";
        // const bs = new BaseTexture('assets/textures/cursor/shining.png')
        // const texture = new Texture(bs)
        // const shining = new Sprite(texture)
        // shining.zIndex = 100001
        // App.instance.stage.addChild(shining);
    }
}

export default new Cursor();
